<template>
  <!-- Navbar -->
  <nav
    class="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
  >
    <div
      class="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
    >
      <!-- Breadcrumbs -->
      <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-3 text-white text-sm font-medium uppercase" v-html="getBreadcrumbs()">

        </ol>
      </nav>

      <!-- Form -->
      <!-- <form
        class="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3"
      >
        <div class="relative flex w-full flex-wrap items-stretch">
          <span
            class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
          >
            <i class="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search here..."
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form> -->
      <!-- User -->
      <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
        <user-dropdown />
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import { UseAppStore } from '@/stores/AppStore';

export default {
  setup(){
    const appStore = UseAppStore();
    return {
      appStore,
      getBreadcrumbs: () => {
        return Object.keys(appStore.breadcrumbs).map((b, index) => {
          let breadcrumb = appStore.breadcrumbs[b];
          console.log(b)
          if(index === 0){
            return `<li class="inline-flex items-center">
                        <a href="${breadcrumb.url}" class="inline-flex items-center  hover:text-paxel-500">
                          <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                          ${breadcrumb.label}
                        </a>
                     </li>`;
          }else if(Object.keys(appStore.breadcrumbs).length - 1 == index){
            return `<li aria-current="page">
                                <div class="flex items-center">
                                  <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                                  <span class="ml-1 text-sm font-medium text-paxel-500 md:ml-2 dark:text-gray-400">${breadcrumb.label}</span>
                                </div>
                              </li>`;
          } else{
            return `<li>
                                <div class="flex items-center">
                                  <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                                  <a href="${breadcrumb.url}" class="ml-1 text-sm font-medium md:ml-2 dark:text-gray-400 dark:hover:text-white">
                                    ${breadcrumb.label}
                                  </a>
                                </div>
                              </li>`;
          }
        }).join("");
      }
    }
  },
  components: {
    UserDropdown,
  },
};
</script>
